<template>
  <div class="pag">
    <div class="title">
      <p class="is-size-4" align="left"><b>Aniversariantes</b></p>
    </div>

    <div class="containerTable">
      <div class="box">
        <div class="top-buttons">
          <b-field>
            <b-radio-button
              v-model="time"
              native-value="Hoje"
              type="is-primary is-light is-outlined"
            >
              <span>Hoje</span>
            </b-radio-button>
            <b-radio-button
              v-model="time"
              native-value="Semana"
              type="is-primary is-light is-outlined"
            >
              <span>Semana</span>
            </b-radio-button>
            <b-radio-button
              v-model="time"
              native-value="Mês"
              type="is-primary is-light is-outlined"
            >
              <span>Mês</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="columns">
          <div class="column is-16-mobile">
            <b-table
              :data="fields"
              :columns="labels"
              :paginated="true"
              :pagination-simple="true"
              :per-page="perPage"
              striped
              bordered
            >
              <template slot="footer">
                <div class="level" style="padding-bottom: 0">
                  <div class="level-left"></div>
                  <div class="left-center"></div>
                  <div class="level-right">
                    <b-select v-model="perPage" size="is-small">
                      <option value="10">10 por página</option>
                      <option value="25">25 por página</option>
                      <option value="50">50 por página</option>
                      <option value="100">100 por página</option>
                    </b-select>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-buttons">
      <div class="level">
        <div class="level-left">
          <b-button
            id="buttonList"
            label="Email"
            type="is-info is-light"
            @click="showModal()"
          />
        </div>
        <b-button
          type="is-primary"
          icon-left="users"
          :disabled="isLoading"
          @click="export2Csv"
          >Exportar Lista</b-button
        >
      </div>
    </div>
    <b-modal :active.sync="openModal" :can-cancel="true">
      <article class="message is-primary is-medium">
        <div class="message-header">
          <p>Fale com a gente</p>
          <button
            class="delete"
            aria-label="delete"
            @click="openModal = false"
          ></button>
        </div>
        <div class="message-body">
          Caso seja do seu interesse a funcionalidade de envio de Email para
          aniversariantes, deixe que a gente saiba, fale com a gente
          <a
            href="mailto:julio.fonte.freire@elcoma.com.br?subject=Função aniversariantes"
            >aqui</a
          >
        </div>
      </article>
    </b-modal>
  </div>
</template>

<script>
import Webservices from "@/Webservices";
import store from "@/store";
import { mapGetters } from "vuex";
var moment = require("moment");
var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;
var moment = require("moment");

const ws = new Webservices();
export default {
  data() {
    return {
      perPage: 10,
      isLoading: false,
      openModal: false,
      fields: [
        { name: "teste", email: "teste@live.com", timestamp: "11/12/2021" },
        { name: "teste1", email: "teste@hotmail.com", timestamp: "15/12/2021" },
      ],
      labels: [
        {
          field: "name",
          label: "Nomes",
          centered: true,
        },
        {
          field: "email",
          label: "Emails",
          centered: true,
        },
        {
          field: "timestamp",
          label: "Data",
          centered: true,
        },
      ],
      time: "hoje",
    };
  },
  methods: {
    export2Csv() {
      const json2csvParser = new Json2csvParser(this.labels);
      const csv = json2csvParser.parse(this.getUsers);

      var blob = new Blob([csv], {
        type: "text/csv",
      });

      FileSaver.saveAs(blob, "respostas.csv");
    },
    showModal() {
      this.openModal = true;
    },
  },
  computed: {
    getUsers() {
      return this.fields;
    },
  },
};
</script>

<style scoped>
.titleBox {
  font-size: 22px;
}
.pag {
  font-family: Sans-Serif;
}

#buttonList {
  font-size: 15px;
}

.textModal {
  font-family: sans-serif;
  font-size: 20px;
}

.top-buttons {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}
.bottom-buttons {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Birthday.vue